import react from "react"

const Slider=()=>{
    return(
        <>
            <div>
                <h1 style={{fontSize:"30px"}}>CONNECT WITH OVER 10 MILLION JEFIT MEMBERS</h1>
                <h3 style={{fontSize:"25px"}}>As the most active workout community, we invite you and your friends to join us and support each other.</h3>
            </div>
            <div className="slider">
                <div className="slide-track">
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/6members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/13members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/14members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/15members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/17members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/15members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/17members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/20members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/7members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/19members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/2members-150x150.png.webp"></img>

                    </div>
                
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/16members-150x150.png.webp"></img>

                    </div>
                    <div className="slide">
                        <img src="https://www.jefit.com/wp/wp-content/uploads/2021/11/12members-150x150.png.webp"></img>

                    </div>
                    

                </div>

            </div>
            <br/>
            <br/>
            <br/>
            
            <div style={{marginBottom:"40px"}}>
                <button className="btn" >Join Now</button>
            </div>
        </>
      
    )
}

export  default Slider